import OnvoBase from "../base.js";
import { Message } from "../types/index.js";
export class OnvoQuestion extends OnvoBase {
  #id: string;

  constructor(id: string, apiKey: string, options?: { endpoint: string }) {
    super(apiKey, options);
    this.#id = id;
  }

  /**
   * Exports the question in the specified format.
   *
   * @param {string} messageId - The id of the message to export.
   * @param {("svg" | "csv" | "xlsx" | "png" | "jpeg")} format - The format to export the question in.
   * @return {Promise<Blob>} A promise that resolves to a Blob representing the exported question.
   */
  exportMessage(
    messageId: string,
    format: "svg" | "csv" | "xlsx" | "png" | "jpeg", theme: "light" | "dark" = "light"
  ): Promise<Blob> {
    return this.fetchBlob(
      `/api/questions/${this.#id
      }/messages/${messageId}/export?theme=${theme}&format=${format}`
    ) as Promise<Blob>;
  }

  /**
   * Retrieves the messages for the question.
   *
   * @return {Promise<Message[]>} A promise that resolves to an array of messages.
   */
  getMessages(): Promise<Message[]> {
    return this.fetchBase(
      `/api/questions/${this.#id}/messages`
    ) as Promise<Message[]>;
  }

  /**
   * Updates the messages for the question.
   *
   * @param {string} content - The text content to update.
   * @return {Promise<Message & { _meta: {status: string, url: string} }>} A promise that resolves to the updated message.
   */
  completion(content: string): Promise<Message & { _meta: { status: string, url: string } }> {
    return this.fetchBase(
      `/api/questions/${this.#id}/messages`,
      "POST",
      { content }
    ) as Promise<Message & { _meta: { status: string, url: string } }>;
  }

  /**
   * Updates a message for the question.
   *
   * @param {string} messageId - The id of the message to update.
   * @param {string} content - The content of the message to update.
   * @return {Promise<Message & { _meta: {status: string, url: string} }>} A promise that resolves to the updated message.
   */
  updateMessage(messageId: string, content: string): Promise<Message & { _meta: { status: string, url: string } }> {
    return this.fetchBase(
      `/api/questions/${this.#id}/messages/${messageId}`,
      "PUT",
      { content }
    ) as Promise<Message & { _meta: { status: string, url: string } }>;
  }
}

